import type { RouteMeta, RouteRecordRaw } from 'vue-router'

import { keys } from '@/app/i18n'
import type { BreadcrumbItem } from '@/app/router/meta'

/**
 * The vendors module's routes (WP-09, wp/quotes §3 — OPEN-12 (b): the register is its own module, as it is its own nav
 * entry, ACL module and API module): the three manifest rows, paths and names from it (D-15); the legacy
 * `/ac/vendors/create` and `/ac/vendors/edit/:id` reach them through the generated legacy redirects. `edit-vendor` is
 * linked from WP-08 / WP-10 (client names) by name.
 *
 * FX-058 / NEW-27: legacy `meta.module` / `mode` were never evaluated (any signed-in user opened the pages by URL); the
 * guard checks `resource` (D-21): Vendors read for the list — the permission `GET vendors` needs — and write for the
 * editor (every vendor write needs it).
 */
const crumb = (text: string, to?: string): BreadcrumbItem => (to ? { text, to } : { text, active: true })

const VendorListView = () => import('./views/VendorListView.vue')
const VendorEditView = () => import('./views/VendorEditView.vue')

const editorMeta = (title: string): RouteMeta => ({
  software: 'ac',
  resource: 'vendors',
  action: 'write',
  navActiveLink: 'vendors',
  pageTitle: title,
  breadcrumb: [crumb(keys.t('vendors.route.title.clientsVendors'), '/ac/vendors'), crumb(title)],
})

const routes: RouteRecordRaw[] = [
  {
    path: '/ac/vendors',
    name: 'vendors',
    component: VendorListView,
    meta: {
      software: 'ac',
      resource: 'vendors',
      pageTitle: keys.t('vendors.route.title.clientsVendors'),
      breadcrumb: [crumb(keys.t('vendors.route.title.clientsVendors'), '/ac/vendors')],
    },
  },
  {
    path: '/ac/vendors/new',
    name: 'create-vendor',
    component: VendorEditView,
    meta: editorMeta(keys.t('vendors.route.title.createContact')),
  },
  {
    path: '/ac/vendors/:id(\\d+)/edit',
    name: 'edit-vendor',
    component: VendorEditView,
    meta: editorMeta(keys.t('vendors.route.title.editClientVendor')),
  },
]

export default routes
